import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Labels } from 'src/interfaces/enums.model';
import { MenuItem } from '../desktop-menu.model';

/**
 * Карточка позиции на десктопе (docs/design/README.md приложения Edim, раздел 16):
 * текст слева, фото справа, маркеры на фото; стоп-лист — приглушённо, не открывается
 */
@Component({
    selector: 'app-desktop-item-card',
    templateUrl: './desktop-item-card.component.html',
    styleUrls: ['./desktop-item-card.component.css'],
    standalone: false
})
export class DesktopItemCardComponent {
  @Input({ required: true }) entry!: MenuItem;
  /** Маркеры, которые в этом блоке не выводятся (в «Новинках» — «Новинка») */
  @Input() hideLabels: Labels[] = [];
  @Output() open = new EventEmitter<void>();

  constructor(private dataService: DataService) {}

  get labels(): Labels[] {
    return this.entry.item.labels.filter((label) => !this.hideLabels.includes(label));
  }

  get currency(): string {
    return this.dataService.locale?.currency ?? '';
  }

  get unit(): string {
    return this.dataService.locale?.units?.get(this.entry.item.unit) ?? '';
  }

  onClick(): void {
    if (!this.entry.stoplist) this.open.emit();
  }
}
